import { createEntityAdapter } from "@ngrx/entity";
import { createFeature, createReducer, on } from "@ngrx/store";
import * as OverviewLocationsActions from "./locations.actions";
import { OverviewLocationsCoordinates } from "@midas/shared/common";

export const OVERVIEW_LOCATIONS = 'overviewLocations';

export interface OverviewLocationsState {
  location: OverviewLocationsCoordinates | null;
  loaded: boolean;
}

export const overviewLocationsAdapter = createEntityAdapter<OverviewLocationsCoordinates>();

const initialState: OverviewLocationsState = {
  location: null,
  loaded: false,
};

export const OverviewLocationsFeature = createFeature({
  name: OVERVIEW_LOCATIONS,
  reducer: createReducer(
    initialState,
    on(OverviewLocationsActions.wasteLocations, (state): OverviewLocationsState => {
      return {
        ...state,
        loaded: false,
      };
    }),
    on(OverviewLocationsActions.wasteLocationsSuccess, (state, { data }): OverviewLocationsState => {
      return {
        ...state,
        location: data,
        loaded: true,
      };
    }),
  ),
});
